import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';

import { forEach } from 'lodash';
import { EmployeeStatusesService } from '../employee-statuses.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface WorkShiftStatus {
  uid?: string;
  int_begin: string;
  int_end: string;
  int_type: number;
  style: {
    width: string | null;
    left: string | null;
  };
}

@Component({
  selector: 'app-employee-work-statuses',
  templateUrl: './employee-work-statuses.component.html',
  styleUrls: ['./employee-work-statuses.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EmployeeWorkStatusesComponent implements OnInit, OnDestroy {
  moment = require('moment');
  statuses: WorkShiftStatus[] = [];
  @Input() workday;
  private _workStatuses;
  @Input()
  set workStatuses(workStatuses) {
    if (!workStatuses) {
      return;
    }
    this._workStatuses = workStatuses;
    this.makeStatuses(workStatuses);
  }
  get workStatuses() {
    return this._workStatuses;
  }
  @Input() employeeId;

  private destroy$ = new Subject<void>();

  constructor(
    private elementRef: ElementRef,
    private employeeStatusesService: EmployeeStatusesService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.employeeStatusesService.isAddData
      .pipe(takeUntil((this.destroy$)))
      .subscribe((state: boolean) => {
        if (state) {
          this.makeStatuses(this.workStatuses);
        }
      });
  }

  getId(s) {
    return btoa(s.int_begin + s.int_end + s.int_type);
  }

  makeStatuses = (workStatuses) => {
    setTimeout(() => {
      forEach(workStatuses, (s) => {
        let status = {
          uid: this.getId(s),
          int_begin: s.int_begin,
          int_end: s.int_end,
          int_type: s.int_type,
          style: { width: null, left: null },
          isIntermediate: false,
        };
        let hoursStart = +this.moment(s.int_begin).format('HH');
        let minutesStart = +this.moment(s.int_begin).format('mm');
        let hoursEnd = +this.moment(s.int_end).format('HH');
        let minutesEnd = +this.moment(s.int_end).format('mm');
        let grandParent = this.elementRef.nativeElement.parentElement.parentElement;

        let childStarts = grandParent.querySelectorAll(
          'div[id="employee_' + this.employeeId + '_' + this.workday + '_' + hoursStart + '"]'
        );
        let childEnds = grandParent.querySelectorAll(
          'div[id="employee_' + this.employeeId + '_' + this.workday + '_' + hoursEnd + '"]'
        );

        let childStart = Array.prototype.find.call(childStarts,
          (child) => this.employeeStatusesService.isToday(child, s.int_begin)
        );
        let childEnd = Array.prototype.find.call(childEnds,
          (child) => this.employeeStatusesService.isToday(child, s.int_end)
        );

        if (childStart && childEnd) {
          let st = (childStart.clientWidth / 60) * minutesStart;
          let ed = (childEnd.clientWidth / 60) * minutesEnd;
          let wh = Math.max(childEnd.offsetLeft + ed - (childStart.offsetLeft + st), 1);

          let workInterval = this.elementRef.nativeElement.querySelector('.work-interval');
          status.style.left = childStart.offsetLeft + st + 'px';
          status.style.width = wh - 1 + 'px';

          // Фейковая подгонка перекрестного интервала двух дней, чтобы скрыть проблему интервала в 2 px,
          // также убрать бордеры
          if (hoursStart === 23 && minutesStart === 59 && hoursEnd === 0 && minutesEnd === 0) {
            workInterval.isIntermediate = true;
          }

          const exists = this.statuses.find((wss: WorkShiftStatus) => wss.uid === status.uid);
          if (!exists) {
            this.statuses.push(status);
          }
        }
      });

      this.cdr.markForCheck();
    }, 4);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
